import { parseURL } from ".";

// Really, JavaScript?
export function reverseString(s: string): string {
    return s.split("").reverse().join("");
}

export function tryShortenLinkToHostname(link: string): string {
    const hostname = parseURL(link)?.hostname;
    if (hostname !== undefined && hostname !== "") {
        return hostname;
    } else {
        return link;
    }
}

export function extractInitials(s: string): string {
    const parts = s.split(" ").splice(0, 2);
    const initials = parts.map(p => p[0]);
    return initials.join("");
}
